/* eslint-disable */
/**
 * Variantes compacta, completa y combinada de evolución.
 *
 * Los métodos operan sobre la instancia de PanelLogic y no mantienen estado global.
 */
const logic = {
  evoCompact(st, buckets, week, EM) {
    const D = this.data,
      keys = ['alarms', 'apv', 'ppa', 'visitas', 'sfr'],
      nB = buckets.length,
      smooth = st.smooth && !week;
    const cmp = st.cmp || [st.sel];
    const agg = (mk, cs) => this.v1MetricAggregate(mk, cs);
    const mean = a => {
      const l = a.filter(v => v != null);
      return l.length ? l.reduce((x, y) => x + y, 0) / l.length : null;
    };
    const hDay = st.hover ? st.hover.di : st.day,
      hb = Math.max(0, buckets.findIndex(b => b.includes(hDay)));
    const idx = e => {
      const r = e.currentTarget.getBoundingClientRect();
      return Math.max(0, Math.min(nB - 1, Math.round((e.clientX - r.left) / r.width * (nB - 1))));
    };
    const xOf = i => nB > 1 ? i : 0.5;
    const cPanels = keys.map(mk => {
      let g = D.rows.map(r => buckets.map(b => agg(mk, b.map(d => r.cells[d]))));
      if (smooth) g = g.map(row => row.map((v, i) => v == null ? null : mean(row.slice(Math.max(0, i - 6), i + 1))));
      const fl = g.flat().filter(v => v != null),
        isS = mk === 'sfr';
      const max = isS ? 150 : Math.max(...fl, 0.001) * 1.05;
      const Y = v => (100 - v / max * 100).toFixed(2);
      const path = row => {
        let d = '',
          pen = false;
        row.forEach((v, i) => {
          if (v == null) {
            pen = false;
            return;
          }
          d += (pen ? 'L' : 'M') + xOf(i) + ' ' + Y(v) + ' ';
          pen = true;
        });
        return d || 'M0 0';
      };
      const col = i => buckets.map((_, bi) => g.map(r => r[bi]).filter(v => v != null));
      const cols = col();
      const hi = cols.map(c => c.length ? Math.max(...c) : null),
        lo = cols.map(c => c.length ? Math.min(...c) : null),
        av = cols.map(c => c.length ? c.reduce((a, b) => a + b, 0) / c.length : null);
      const band = 'M' + hi.map((v, i) => xOf(i) + ' ' + Y(v ?? 0)).join(' L') + ' L' + lo.map((v, i) => xOf(i) + ' ' + Y(v ?? 0)).reverse().join(' L') + ' Z';
      const fmt = EM[mk].fmt;
      return {
        label: EM[mk].label + (isS ? ' [%]' : ''),
        avg: fmt(fl.reduce((a, b) => a + b, 0) / fl.length),
        yMax: isS ? '150' : fmt(max),
        vb: '0 0 ' + Math.max(1, nB - 1) + ' 100',
        band,
        avgLine: path(av),
        ref: isS ? 'M0 ' + Y(100) + ' H' + (nB - 1) : 'M0 0',
        refDisp: isS ? 'block' : 'none',
        others: g.filter((_, ci) => !cmp.includes(ci)).map(path),
        sel: cmp.map(ci => ({
          d: path(g[ci]),
          c: this.cageColor(ci)
        })),
        vals: cmp.map(ci => ({
          name: D.rows[ci].name.replace(' A', ''),
          c: this.cageColor(ci),
          val: g[ci][hb] == null ? 'ayuno' : fmt(g[ci][hb])
        })).concat([{
          name: 'prom.',
          c: '#b8c1ce',
          val: av[hb] == null ? '—' : fmt(av[hb])
        }]),
        move: e => {
          const di = buckets[idx(e)][0];
          const x = this.state.hover;
          if (!x || x.di !== di) this.setState({
            hover: {
              ci: st.sel,
              di
            }
          });
        },
        click: e => this.setState({
          day: buckets[idx(e)][0]
        })
      };
    });
    const b = buckets[hb];
    return {
      cPanels,
      cX: (nB > 1 ? hb / Math.max(1, nB - 1) * 100 : 50).toFixed(2) + '%',
      cX0: D.days[buckets[0][0]],
      cXm: D.days[buckets[Math.floor(nB / 2)][0]],
      cX1: D.days[buckets[nB - 1][0]],
      cDay: (week ? 'Semana ' + D.days[b[0]] + ' – ' + D.days[b[b.length - 1]] : D.days[b[0]]) + (smooth ? ' · media 7 d' : ''),
      smoothBg: smooth ? 'rgba(46,179,238,0.12)' : 'transparent',
      smoothTxt: smooth ? '#e4e9f0' : '#8793a6',
      smoothTrack: smooth ? 'oklch(0.6 0.12 250)' : '#2a3446',
      smoothKnob: smooth ? "1.296296vh" : "0.185185vh",
      toggleSmooth: () => this.setState(s => ({
        smooth: !s.smooth
      })),
      cageChips: D.rows.map((r, ci) => {
        const on = cmp.includes(ci);
        return {
          name: r.name,
          dot: on ? this.cageColor(ci) : '#3a475c',
          bg: on ? 'rgba(46,179,238,0.08)' : 'transparent',
          border: on ? this.cageColor(ci) : '#1c2636',
          txt: on ? '#e4e9f0' : '#8793a6',
          onClick: () => this.setState(s => {
            const c = s.cmp || [s.sel];
            let n = c.includes(ci) ? c.filter(x => x !== ci) : [...c, ci].slice(-4);
            if (!n.length) n = [ci];
            return {
              cmp: n,
              sel: ci
            };
          })
        };
      })
    };
  },
  evoAll(st, tol, pct, stripes, buckets, week, EM, only) {
    const D = this.data,
      keys = only || ['alarms', 'apv', 'ppa', 'visitas', 'sfr'],
      tr = st.evoAxis === 'jaula',
      nC = D.rows.length,
      nB = buckets.length;
    const agg = (mk, cs) => this.v1MetricAggregate(mk, cs);
    const hDay = st.hover ? st.hover.di : st.day,
      hb = Math.max(0, buckets.findIndex(b => b.includes(hDay)));
    const hc = st.hover && st.hover.gc != null ? st.hover.gc : null,
      focus = st.gFocus ?? null;
    const opOf = ci => focus == null || focus === ci ? 1 : 0.18;
    const nX = tr ? nC : nB;
    const idx = e => {
      const r = e.currentTarget.getBoundingClientRect();
      return Math.max(0, Math.min(nX - 1, Math.floor((e.clientX - r.left) / r.width * nX)));
    };
    const f2 = v => v.toFixed(2);
    const gPanels = keys.map(mk => {
      const g = D.rows.map(r => buckets.map(b => agg(mk, b.map(d => r.cells[d])))),
        fmt = EM[mk].fmt,
        isS = mk === 'sfr';
      const stack = EM[mk].sum && !tr;
      let max;
      if (stack) max = Math.max(...buckets.map((_, bi) => g.reduce((a, r) => a + (r[bi] || 0), 0)), 0.001) * 1.05;else max = isS ? 150 : Math.max(...g.flat().filter(v => v != null), 0.001) * 1.08;
      const Y = v => 100 - Math.min(v, max) / max * 100;
      let layers;
      if (stack) {
        const base = Array(nB).fill(0);
        layers = D.rows.map((r, ci) => {
          let d = '';
          g[ci].forEach((v, bi) => {
            if (!v) return;
            const y0 = Y(base[bi]),
              y1 = Y(base[bi] + v);
            base[bi] += v;
            d += 'M' + f2(bi + 0.12) + ' ' + f2(y0) + ' H' + f2(bi + 0.88) + ' V' + f2(y1) + ' H' + f2(bi + 0.12) + ' Z ';
          });
          return {
            d: d || 'M0 0',
            fill: this.cageColor(ci),
            stroke: 'none',
            sw: 0,
            op: opOf(ci)
          };
        });
      } else if (!tr) {
        layers = D.rows.map((r, ci) => {
          let d = '';
          g[ci].forEach((v, bi) => {
            if (v != null) d += 'M' + f2(bi + 0.5) + ' ' + f2(Y(v)) + ' h0.001 ';
          });
          return {
            d: d || 'M0 0',
            fill: 'none',
            stroke: this.cageColor(ci),
            sw: focus === ci ? 7 : 5,
            op: opOf(ci)
          };
        });
      } else {
        layers = D.rows.map((r, ci) => {
          let d = '';
          const vs = g[ci].filter(v => v != null);
          g[ci].forEach((v, bi) => {
            if (v != null) d += 'M' + f2(ci + 0.5 + (bi * 37 % 11 - 5) / 20) + ' ' + f2(Y(v)) + ' h0.001 ';
          });
          return {
            d: d || 'M0 0',
            fill: 'none',
            stroke: this.cageColor(ci),
            sw: 4,
            op: focus == null || focus === ci ? 0.55 : 0.12
          };
        });
        D.rows.forEach((r, ci) => {
          const vs = g[ci].filter(v => v != null);
          if (!vs.length) return;
          const m = vs.reduce((a, b) => a + b, 0) / vs.length;
          layers.push({
            d: 'M' + f2(ci + 0.12) + ' ' + f2(Y(m)) + ' H' + f2(ci + 0.88),
            fill: 'none',
            stroke: this.cageColor(ci),
            sw: 3,
            op: opOf(ci)
          });
        });
        let hd = '';
        D.rows.forEach((r, ci) => {
          const v = g[ci][hb];
          if (v != null) hd += 'M' + f2(ci + 0.5) + ' ' + f2(Y(v)) + ' h0.001 ';
        });
        layers.push({
          d: hd || 'M0 0',
          fill: 'none',
          stroke: '#e4e9f0',
          sw: 6,
          op: 1
        });
      }
      let info;
      const colV = g.map((r, ci) => ({
        ci,
        v: r[hb]
      })).filter(o => o.v != null);
      if (tr) {
        const ci = hc ?? focus ?? st.sel,
          vs = g[ci].filter(v => v != null);
        info = D.rows[ci].name + ' · prom. ' + fmt(vs.reduce((a, b) => a + b, 0) / Math.max(1, vs.length)) + ' · día marcado ' + (g[ci][hb] == null ? 'ayuno' : fmt(g[ci][hb]));
      } else if (!colV.length) info = 'Todas en ayuno';else {
        const top = colV.reduce((a, b) => b.v > a.v ? b : a),
          low = colV.reduce((a, b) => b.v < a.v ? b : a),
          sum = colV.reduce((a, b) => a + b.v, 0);
        info = (stack ? 'Total ' + fmt(sum) : 'Prom. ' + fmt(sum / colV.length)) + ' · máx. ' + D.rows[top.ci].name + ' ' + fmt(top.v) + ' · mín. ' + D.rows[low.ci].name + ' ' + fmt(low.v);
        if (focus != null) info = D.rows[focus].name + ' ' + (g[focus][hb] == null ? 'ayuno' : fmt(g[focus][hb])) + ' · ' + info;
      }
      return {
        label: EM[mk].label + (isS ? ' [%]' : ''),
        kind: stack ? 'barras apiladas por jaula' : tr ? 'puntos = días · raya = promedio' : 'un punto por jaula',
        info,
        yMax: isS ? '150' : fmt(max),
        vb: '0 0 ' + nX + ' 100',
        layers,
        ref: isS ? 'M0 ' + f2(Y(100)) + ' H' + nX : 'M0 0',
        refDisp: isS ? 'block' : 'none',
        refPos: (100 / 150 * 100).toFixed(2) + '%',
        move: e => {
          const i = idx(e);
          const x = this.state.hover;
          if (tr) {
            if (!x || x.gc !== i) this.setState({
              hover: {
                ci: i,
                gc: i,
                di: x ? x.di : st.day
              }
            });
          } else {
            const di = buckets[i][0];
            if (!x || x.di !== di) this.setState({
              hover: {
                ci: st.sel,
                di
              }
            });
          }
        },
        click: e => {
          const i = idx(e);
          tr ? this.setState(s => ({
            gFocus: s.gFocus === i ? null : i,
            sel: i
          })) : this.setState({
            day: buckets[i][0]
          });
        }
      };
    });
    const b = buckets[hb],
      hx = tr ? hc ?? focus : hb;
    const gLabs = tr ? D.rows.map((r, ci) => ({
      lab: r.name.replace(' A', ''),
      al: 'center',
      c: this.cageColor(ci)
    })) : [{
      lab: D.days[buckets[0][0]],
      al: 'left',
      c: '#5a667a'
    }, {
      lab: D.days[buckets[Math.floor(nB / 2)][0]],
      al: 'center',
      c: '#5a667a'
    }, {
      lab: D.days[buckets[nB - 1][0]],
      al: 'right',
      c: '#5a667a'
    }];
    return {
      gPanels,
      gLabs,
      gLabN: gLabs.length,
      gH: only ? 300 : 150,
      gX: hx == null ? '0%' : (hx / nX * 100).toFixed(2) + '%',
      gW: hx == null ? '0%' : (100 / nX).toFixed(2) + '%',
      gDay: tr ? 'Eje X = jaulas · día marcado ' + D.days[b[0]] : week ? 'Semana ' + D.days[b[0]] + ' – ' + D.days[b[b.length - 1]] : D.days[b[0]],
      gHint: tr ? 'Puntos blancos = día marcado' : ''
    };
  },
  evoMix(st, EM, buckets, week, sel, colorOf, xt) {
    const D = this.data,
      nB = buckets.length,
      M = (st.sMixM || ['alarms', 'ppa', 'visitas']).filter(k => k !== 'sfr');
    const GL = ['●', '▲', '■', '◆', '✕', '▼'],
      DASH = ['none', '9 5', '2 4', '12 4 2 4', '5 3', '16 6'],
      AXC = ['#75b7ff', '#68d5a2', '#df92e7', '#f2c75c', '#ff9466', '#a99bea'];
    const aggK = (k, cs) => this.v1MetricAggregate(k, cs);
    const nice = raw => {
      const s = raw / 4,
        p = Math.pow(10, Math.floor(Math.log10(s || 1))),
        n = s / p,
        st = (n <= 1 ? 1 : n <= 2 ? 2 : n <= 2.5 ? 2.5 : n <= 5 ? 5 : 10) * p;
      return {
        step: st,
        max: st * Math.ceil(raw / st)
      };
    };
    const S = M.map((k, j) => {
      const g = sel.map(ci => buckets.map(bk => aggK(k, bk.map(d => D.rows[ci].cells[d]))));
      const vals = g.flat().filter(v => v != null);
      const raw = k === 'sfr' ? Math.max(150, ...vals) : Math.max(...vals, 0.001) * 1.05;
      const n = nice(raw);
      return {
        k,
        j,
        g,
        max: n.max,
        step: n.step,
        em: EM[k],
        axisC: EM[k].color || AXC[j % AXC.length],
        short: {
          alarms: 'Alarmas',
          apv: 'Al./vis.',
          apt: 'Al./t',
          ppa: 'PPA',
          visitas: 'Visitas',
          kg: 'Alimento (ton)'
        }[k] || EM[k].label
      };
    });
    const tl = (s, v) => s.em.tickFmt ? s.em.tickFmt(v, s.step) : s.step < 1 ? v.toFixed(s.step < 0.1 ? 2 : 1) : String(Math.round(v));
    const PAT = [c => c, c => 'repeating-linear-gradient(45deg,' + c + " 0 0.185185vh,transparent 0.185185vh 0.462963vh)", c => 'repeating-linear-gradient(0deg,' + c + " 0 0.138889vh,transparent 0.138889vh 0.37037vh)", c => 'radial-gradient(' + c + " 0.111111vh,transparent 0.148148vh) 0 0/0.37037vh 0.37037vh", c => 'repeating-linear-gradient(45deg,' + c + " 0 0.138889vh,transparent 0.138889vh 0.462963vh),repeating-linear-gradient(-45deg," + c + " 0 0.138889vh,transparent 0.138889vh 0.462963vh)", c => 'repeating-linear-gradient(90deg,' + c + " 0 0.138889vh,transparent 0.138889vh 0.37037vh)"];
    const patternOf = (s, c) => (s.em.pattern || PAT[s.j % PAT.length])(c);
    const nG = S.length * sel.length,
      slotW = 0.84 / nG,
      marks = [];
    S.forEach((s, mi) => sel.forEach((ci, si) => {
      const row = s.g[si],
        c = colorOf(ci),
        j = mi * sel.length + si;
      row.forEach((v, i) => {
        if (v == null || v <= 0) return;
        const x0 = i + 0.08 + j * slotW;
        marks.push({
          l: (x0 / nB * 100).toFixed(3) + '%',
          w: (slotW * (nG > 1 ? 0.9 : 1) / nB * 100).toFixed(3) + '%',
          h: Math.min(100, v / s.max * 100).toFixed(2) + '%',
          bg: patternOf(s, c),
          c
        });
      });
    }));
    const lines = [];
    const xPct = i => (i + 0.5) / nB * 100;
    const s0 = S[0];
    const hDay = st.hover ? st.hover.di : null,
      hb = hDay == null ? -1 : buckets.findIndex(bk => bk.includes(hDay));
    const idx = e => {
      const r = e.currentTarget.getBoundingClientRect();
      return Math.max(0, Math.min(nB - 1, Math.floor((e.clientX - r.left) / r.width * nB)));
    };
    const hbb = hb < 0 ? null : buckets[hb];
    const PN = ['sólida', 'diagonal', 'horizontal', 'puntos', 'cuadriculada', 'vertical'];
    return {
      sInsight: 'Combinando ' + S.map(s => s.em.label + ' (' + (s.em.pattern ? 'diagonal' : PN[s.j]) + ')').join(', ') + ' · cada métrica con su propia escala' + (this.props.groupMode === 'day' && nG > 3 ? ' · usa Semanal para barras más anchas' : ''),
      sVB: '0 0 ' + nB + ' 100',
      sBars: [],
      sLines: lines,
      sMarks: marks,
      sAvg: 'M0 0',
      sRef: 'M0 0',
      sRefDisp: 'none',
      sXTicks: xt,
      sLegend: [],
      sYTicks: s0 ? [...Array(Math.round(s0.max / s0.step) + 1)].map((_, i) => ({
        pos: (i * s0.step / s0.max * 100).toFixed(2) + '%',
        lab: tl(s0, i * s0.step)
      })) : [],
      sYAxes: S.map(s => ({
        name: s.em.label + (s.em.unit ? ' (' + s.em.unit + ')' : ''),
        short: s.short,
        c: s.axisC,
        ticks: [...Array(Math.round(s.max / s.step) + 1)].map((_, i) => ({
          pos: (i * s.step / s.max * 100).toFixed(2) + '%',
          lab: tl(s, i * s.step)
        }))
      })),
      sEnd: [],
      sMixLeg: S.map(s => ({
        bg: patternOf(s, s.axisC),
        name: s.em.label
      })),
      sMove: e => {
        const di = buckets[idx(e)][0];
        const x = this.state.hover;
        if (!x || x.di !== di) this.setState({
          hover: {
            ci: st.sel,
            di
          }
        });
      },
      sClick: e => this.setState({
        day: buckets[idx(e)][0]
      }),
      sX: hb < 0 ? '0%' : xPct(hb) + '%',
      sTipDisp: hb < 0 ? 'none' : 'flex',
      sTipTx: hb < 0 ? "translateX(0.625vw)" : xPct(hb) < 28 ? "translateX(0.625vw)" : xPct(hb) > 72 ? "translateX(calc(-100% - 0.625vw))" : 'translateX(-50%)',
      sTipW: Math.min(760, Math.max(190, S.length * 170)) / 19.2 + 'vw',
      sTipDate: hbb ? this.periodLabel(hbb, true) : '',
      sTipRows: [],
      sTipColumns: hb < 0 ? [] : S.map(s => ({
        name: s.em.label,
        range: '0–' + tl(s, s.max),
        c: s.axisC,
        bg: patternOf(s, s.axisC),
        rows: sel.map((ci, si) => {
          const v = s.g[si][hb];
          return {
            name: D.rows[ci].name,
            c: colorOf(ci),
            val: v == null ? 'ayuno' : s.em.fmt(v),
            sw: "0.740741vh",
            sh: "0.740741vh",
            ring: 'none',
            nc: '#b8c1ce',
            fw: ci === st.sel ? 600 : 400,
            mt: '0',
            pt: '0',
            bt: 'none',
            pl: '0'
          };
        }).sort((a, b) => a.name.localeCompare(b.name, undefined, {
          numeric: true,
          sensitivity: 'base'
        }))
      })),
      sTipFoot: this.props.groupMode === 'day' ? 'Clic para ver este día en el detalle' : 'Clic para ver el inicio de este período en el detalle',
      showTypes: false,
      sAxes: []
    };
  },
  sfrCard(st, tol) {
    const r = this.evoSimple({
        ...st,
        sMix: false,
        sMetric: 'sfr',
        sType: 'barras',
        sAxis: st.sAxis === 'jaula' ? 'jaula' : 'fecha'
      }, tol),
      D = this.data;
    const B = this._evoB || [],
      hDay = st.hover ? st.hover.di : st.day,
      bi = Math.max(0, B.findIndex(b => b.includes(hDay)));
    const resolution = this.props.groupMode || 'day',
      cells = D.rows[st.sel].cells,
      bk = B[bi] || [st.day];
    const v = this.v1MetricAggregate('sfr', bk.map(d => cells[d]));
    const dev = v == null ? null : v - 100,
      col = v == null ? '#8793a6' : Math.abs(dev) <= tol ? '#e4e9f0' : dev < 0 ? 'oklch(0.7 0.14 250)' : 'oklch(0.72 0.15 55)';
    const max = (() => {
      const t = r.sYTicks;
      return t.length ? parseFloat(t[t.length - 1].lab) : 150;
    })();
    const inv = st.sAxis === 'jaula',
      selected = [st.sel, ...(st.cmp8 || []).filter(ci => ci !== st.sel)],
      foodTotal = cs => {
        // Like the comparison chart, keep delivered_food in backend tonnes.
        const values = cs.filter(c => c && !c.missing && Number.isFinite(c.kg)).map(c => c.kg);
        return values.length ? values.reduce((sum, value) => sum + value, 0) : null;
      },
      foodSeries = inv ? B.map((bucket, di) => ({
        name: this.periodLabel(bucket),
        c: r.sLegend8[di].c,
        values: D.rows.map(row => foodTotal(bucket.map(index => row.cells[index]))),
        sfrValues: D.rows.map(row => this.v1MetricAggregate('sfr', bucket.map(index => row.cells[index])))
      })) : selected.map((ci, i) => ({
        name: D.rows[ci].name,
        c: r.sLegend8[i].c,
        values: B.map(b => foodTotal(b.map(di => D.rows[ci].cells[di]))),
        sfrValues: B.map(b => this.v1MetricAggregate('sfr', b.map(di => D.rows[ci].cells[di])))
      }));
    const foodRawMax = Math.max(0, ...foodSeries.flatMap(series => series.values).filter(Number.isFinite)) * 1.05 || 1,
      foodStep = (() => {
        const target = foodRawMax / 5,
          power = Math.pow(10, Math.floor(Math.log10(target))),
          fraction = target / power;
        return (fraction <= 1 ? 1 : fraction <= 2 ? 2 : fraction <= 2.5 ? 2.5 : fraction <= 5 ? 5 : 10) * power;
      })(),
      foodMax = foodStep * Math.ceil(foodRawMax / foodStep),
      foodGroups = inv ? D.rows.length : B.length,
      slot = (inv ? 0.76 : 0.8) / Math.max(1, foodSeries.length),
      barWidth = slot * 0.42,
      barX = (i, j) => i + (inv ? 0.12 : 0.1) + (j + 0.04) * slot;
    const foodBars = [],
      sfrBars = foodSeries.map((series, j) => {
        // Each cage/day gets a solid SFR bar and a hatched food bar beside it.
        let d = '';
        series.sfrValues.forEach((value, i) => {
          if (!(value > 0)) return;
          const x = barX(i, j);
          d += 'M' + x.toFixed(3) + ' 100 V' + (100 - value / max * 100).toFixed(2) + ' H' + (x + barWidth).toFixed(3) + ' V100 Z ';
        });
        series.values.forEach((value, i) => {
          if (!(value > 0)) return;
          foodBars.push({
            left: ((barX(i, j) + slot * 0.5) / foodGroups * 100).toFixed(3) + '%',
            width: (barWidth / foodGroups * 100).toFixed(3) + '%',
            height: (value / foodMax * 100).toFixed(2) + '%',
            c: series.c
          });
        });
        return { d: d || 'M0 0', c: series.c };
      }),
      foodHover = inv ? st.sHc ?? -1 : st.hover ? B.findIndex(b => b.includes(st.hover.di)) : -1,
      tipRows = foodHover < 0 ? [] : foodSeries.map(series => {
        const sfrRow = r.sTipRows.find(row => row.name === series.name),
          food = series.values[foodHover];
        if (!sfrRow && food == null) return null;
        return {
          name: series.name,
          c: series.c,
          val: sfrRow ? sfrRow.val : '—',
          food: food == null ? '—' : food.toLocaleString('es-CL', { maximumFractionDigits: 3 }) + ' ton'
        };
      }).filter(Boolean),
      tipDisplay = tipRows.length ? 'flex' : 'none';
    return {
      fVB: r.sVB,
      fFoodBars: foodBars,
      fFoodYTicks: Array.from({ length: Math.round(foodMax / foodStep) + 1 }, (_, i) => ({
        pos: (i * foodStep / foodMax * 100).toFixed(2) + '%',
        lab: (i * foodStep).toLocaleString('es-CL', { maximumFractionDigits: Math.max(0, 1 - Math.floor(Math.log10(foodStep))) })
      })),
      fBars: sfrBars,
      fAvg: r.sAvg,
      fRef: r.sRef,
      fRefPos: (100 / max * 100).toFixed(2) + '%',
      fYTicks: r.sYTicks,
      fXTicks: r.sXTicks.filter((_, i, a) => a.length <= 5 || i % Math.ceil(a.length / 5) === 0),
      fEnd: r.sEnd,
      fX: r.sX,
      fTipDisp: tipDisplay,
      fMove: r.sMove,
      fLeave: r.sLeave,
      fClick: r.sClick,
      fLeg: r.sLegend8,
      fTol: String(tol),
      fBandB: ((100 - tol) / max * 100).toFixed(2) + '%',
      fBandH: (2 * tol / max * 100).toFixed(2) + '%',
      fBig: v == null ? 'Ayuno' : v.toFixed(1) + ' %',
      fBigC: col,
      fBigLab: D.cages[st.sel] + ' · ' + this.periodLabel(bk),
      fDev: dev == null ? '' : Math.abs(dev) <= tol ? 'En objetivo' : (dev > 0 ? '+' : '−') + Math.abs(dev).toFixed(1) + ' pts vs 100 %',
      fDevC: col,
      fSub: ({ day: 'Diario', week: 'Semanal', month: 'Mensual' }[resolution]) + (st.sZoom ? ' · zoom' : ''),
      fTipFlex: tipDisplay,
      fTipTx: r.sTipTx,
      fTipDate: r.sTipDate,
      fTipRows: tipRows,
      ...(() => {
        const sel = [st.sel, ...(st.cmp8 || []).filter(c => c !== st.sel)],
          leg = r.sLegend8 || [];
        const vals = sel.map((ci, i) => {
          const l = D.rows[ci].cells,
            x = this.v1MetricAggregate('sfr', bk.map(d => l[d])),
            dv = x == null ? 0 : x - 100;
          return {
            name: D.rows[ci].name,
            c: (leg[i] || {}).c || '#8793a6',
            val: x == null ? 'ayuno' : x.toFixed(1) + ' %',
            vc: x == null ? '#5a667a' : Math.abs(dv) <= tol ? '#e4e9f0' : dv < 0 ? 'oklch(0.7 0.14 250)' : 'oklch(0.72 0.15 55)'
          };
        });
        return {
          fMulti: sel.length > 1,
          fSingle: sel.length <= 1,
          fVals: vals
        };
      })()
    };
  }
};
export default logic;
